import React from 'react'

import * as S from './styles'

/**
 * @typedef {'auto' | 'always' | 'scroll' | 'hover' | 'never'} ScrollType
 */

/**
 * @typedef {Object} ScrollAreaProps
 * @property {ScrollType} [type]
 * @property {string | number} [maxHeight]
 * @property {string | number} [height]
 * @property {React.ReactNode} children
 */

/**
 * @param {ScrollAreaProps} props
 */
export default function ScrollArea({ type, maxHeight, height, children }) {
  return (
    <S.ScrollArea type={type} mah={maxHeight} h={height}>
      {children}
    </S.ScrollArea>
  )
}
